import icon from '../../icon';

const light = (params) => icon.feature.light(params);

export default light;
